import { Container, Transition, TransitionName, TransitionProps } from '@optimus-web/core';

interface ViewProps extends TransitionProps {
    children: React.ReactNode;
    transition: TransitionName;
}

export const View = ({ transition, children, ...other }: ViewProps) => (
    <Container
        as={Transition}
        name={transition}
        position="absolute"
        width="100%"
        top="0"
        right="0"
        bottom="0"
        left="0"
        minHeight="100%"
        {...other}
    >
        {children}
    </Container>
);
